import React from 'react';

const CheckoutSectionFooter = ({ children, className, align = 'left' }) => (
  <div
    className={`checkout__section-footer checkout__section-footer--${align} ${
      className ? className : ''
    } `}
  >
    {children}
  </div>
);

export default CheckoutSectionFooter;
